import { getProfileById } from "../state-manager.js";
import { fetchFeeds } from "../requests/profiles.js";
import { hydrateFeeds } from "./ui-feeds.js";

export function hydrateSummary(profileId, intake, intakeYesterday) {
  const panel = document.getElementById('app-summary-panel');
  if (panel) panel.classList.remove('hidden');

  const profile = getProfileById(profileId);
  const norm = profile?.daily_norm || 0;
  const diff = intake - norm;
  const percent = norm > 0 ? Math.min((intake / norm) * 100, 100) : 0;
  const diffYesterday = intakeYesterday - norm;
  const percentYestrday = norm > 0 ? Math.min((intakeYesterday / norm) * 100, 100) : 0;

  document.querySelector('#summary-intake strong').textContent = `${intake.toFixed(0)}g`;
  document.querySelector('#summary-norm strong').textContent = `${norm.toFixed(0)}g`;
  document.querySelector('#summary-diff strong').textContent = `${(diff >= 0 ? '+' : '')}${diff.toFixed(0)}g`;
  document.querySelector('#summary-diff-yesterday strong').textContent = `[${(diffYesterday >= 0 ? '+' : '')}${diffYesterday.toFixed(0)}g]`;
  document.getElementById('summary-bar-fill').style.width = `${percent}%`;

  // Optional: color change if overfed
  document.getElementById('summary-bar-fill').style.background =
    diff > 0
      ? 'linear-gradient(90deg, #ff5a5a, #cc0000)' // Overfed = red
      : 'linear-gradient(90deg, #00aaff, #0077cc)'; // Normal = blue

  // Wire refresh button to reload feeds from backend and update UI
  const refreshBtn = document.getElementById('summary-refresh');
  if (refreshBtn) {
    refreshBtn.onclick = async () => {
      refreshBtn.disabled = true;
      try {
        // ensure backend refresh happens and then re-hydrate feeds UI
        await fetchFeeds(profileId);
        await hydrateFeeds(profileId);
      } catch (err) {
        console.error('[Summary] Refresh failed:', err);
      } finally {
        refreshBtn.disabled = false;
      }
    };
  }
}
